/**
 * Homepage hero full height
 */
const heroEl = document.querySelector('.js-home-hero');
if (heroEl) {
  const heroHeight = heroEl.offsetHeight;
  document.addEventListener('DOMContentLoaded', () =>
    heroResize(heroEl, heroHeight)
  );
  window.addEventListener('load', () => heroResize(heroEl, heroHeight));
  window.addEventListener('scroll', () => heroResize(heroEl, heroHeight));
  window.addEventListener('resize', () => heroResize(heroEl, heroHeight));
}

function heroResize(el, height) {
  if (window.scrollY === 0) {
    el.style.height = window.innerHeight + 'px';
  } else {
    el.style.height = height + 'px';
  }
}
